<template>
  <div class="profile">
    <div class="container">
      <!-- Card -->
      <div class="card testimonial-card pt-4">
        <!-- Background color -->
        <div class="card-up indigo lighten-1"></div>

        <!-- Avatar -->
        <div
          class="avatar mx-auto white text-info"
          style="  display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 200px;
                    width: 200px;
                    overflow: hidden;
                    border-radius: 50%;
                  "
        >
          <label calss="profi-lab d-block" for="profi" style="cursor: pointer;">
            <input type="file" name="" id="profi" class="d-none" />
            <img
              id="profileImg"
              src="@/assets/image/profilePic.png"
              class="rounded-circle"
              alt="avatar"
              style="width: 200px;"
            />
            <i class="fas fa-pencil-alt" aria-hidden="true"></i>
          </label>
        </div>
        <input
          name=""
          id="saveProfile"
          class="btn btn-primary text-center btn-rounded btn-block disabled"
          type="button"
          value="save"
        />

        <!-- Content -->
        <div class="card-body">
          <!-- Name -->
          <h4 class="card-title" id="profileHeader">
            Utilisateur inconnu
          </h4>
          <hr />

          <div class="modifWrapper" id="modifWrapper">
            <!-- Material input -->
            <div class="md-form">
              <div class="row">
                <div class="col-md-4">
                  <div class="md-form mb-0">
                    <input
                      placeholder="Prénom"
                      type="text"
                      id="nomProfile"
                      class="form-control"
                    />
                    <label for="nomProfile">Prénom</label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="md-form mb-0">
                    <input
                      placeholder="Nom de famille"
                      type="text"
                      id="prenomProfile"
                      class="form-control"
                    />
                    <label for="prenomProfile">Nom de famille</label>
                  </div>
                </div>
                <div class="col-md-4 m-auto">
                  <button
                    class="btn blue-gradient btn-rounded btn-block"
                    id="saveFnameLname"
                  >
                    enregistrer<i
                      class="ml-2 fas fa-pencil-alt"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="md-form">
                  <input
                    placeholder="Email"
                    type="text"
                    id="emailProfile"
                    class="form-control"
                  />
                  <label for="emailProfile">Email</label>
                </div>
              </div>
              <div class="col-md-4 m-auto">
                <button
                  class="btn blue-gradient btn-rounded btn-block"
                  data-toggle="modal"
                  data-target="#modalLoginAvatar2"
                  id="saveEmail"
                >
                  enregistrer<i
                    class="ml-2 fas fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="md-form mt-5">
                  <input
                    placeholder="La date de naissance"
                    style="padding: 0;"
                    type="date"
                    id="dateNaissProfile"
                    class="form-control"
                  />
                  <label for="dateNaissProfile">La date de naissance</label>
                </div>
              </div>
              <div class="col-md-4 m-auto">
                <button
                  class="btn blue-gradient btn-rounded btn-block"
                  id="saveDateNais"
                >
                  enregistrer<i
                    class="ml-2 fas fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="md-form">
                  <input
                    placeholder="L'adresse"
                    type="text"
                    id="adresseProfile"
                    class="form-control"
                  />
                  <label for="adresseProfile">L'adresse</label>
                </div>
              </div>
              <div class="col-md-4 m-auto">
                <button
                  class="btn blue-gradient btn-rounded btn-block"
                  id="saveAdress"
                >
                  enregistrer
                  <i class="ml-2 fas fa-pencil-alt" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div class="md-form">
                  <input
                    placeholder="Numéro de téléphone "
                    type="text"
                    id="numTel"
                    class="form-control"
                  />
                  <label for="numTel">Numéro de téléphone </label>
                </div>
              </div>
              <div class="col-md-4 m-auto">
                <button
                  class="btn blue-gradient btn-rounded btn-block"
                  id="saveNumTel"
                >
                  enregistrer<i
                    class="ml-2 fas fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="md-form">
                  <i class="fas fa-pencil-alt prefix active"></i>
                  <textarea
                    id="descProf"
                    class="md-textarea form-control"
                    rows="3"
                  ></textarea>
                  <label for="descProf" class="active"
                    >décrivez-vous (optionnelle)</label
                  >
                </div>
              </div>
              <div class="col-md-4 m-auto">
                <button
                  class="btn blue-gradient btn-rounded btn-block"
                  id="saveDesc"
                >
                  enregistrer<i
                    class="ml-2 fas fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 mb-2">
                <button
                  class="btn aqua-gradient btn-rounded btn-block my-2"
                  data-toggle="modal"
                  data-target="#modalLoginAvatar3"
                  id="updateMdp"
                >
                  changer le mot de passe
                  <i class="fa fa-key ml-2" aria-hidden="true"></i>
                </button>
              </div>

              <div class="col-md-12">
                <button
                  class="btn peach-gradient btn-rounded btn-block"
                  data-toggle="modal"
                  data-target="#modalLoginAvatar4"
                  id="deleteAc"
                >
                  supprimer mon compte
                  <i class="ml-2 fas fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Card -->
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {};
  }
};
</script>



<style lang="scss" scoped>
</style>